import * as React from "react"

interface Props {
    shouldShowSeparator: boolean
    term: Models.ContextualHelpTerm
}

export const Term = ({ shouldShowSeparator, term }: Props): JSX.Element => {
    return (
        <div
            className="tw-mb-4"
            data-ft-component="term"
            data-ft-term-code={term.code}
            data-ft-term-label={term.label}
            data-ft-term-target={term.target}
        >
            {shouldShowSeparator && (
                <div className="separator-line is-dotted is-dimmed"></div>
            )}
            <header className="step-header">
                <h3 className="tw-my-2">{term.label}</h3>
            </header>
            <div
                className="tw-px-8 tw-py-2 tw-whitespace-pre-line"
                dangerouslySetInnerHTML={{
                    __html: term.content || "",
                }}
            />
        </div>
    )
}

export default Term
